import React from "react";
import { Professional } from "../../../models/Professional";
import { Card, CardBody } from "../../../design/card";
import { Avatar } from "../../../design/avatar";
import InviteProfessionalButton from "../../../components/InviteProfessionalButton";
import { useUser } from "../../../contexts/UserContext";
import { useMatter } from "../../../contexts/MatterContext";
import { Text } from "../../../design/text";
import { Heading } from "../../../design/heading";
import { Link } from "../../../design/link";
import ProfessionalRoleBadge from "../../../components/ProfessionalRoleBadge";

interface Props {
  professional: Professional;
}

const ProfessionalGridItem: React.FC<Props> = ({ professional }) => {
  const { currentMatterId } = useMatter();
  const { currentUser } = useUser();
  return (
    <Card className="p-4 transition-shadow duration-200 hover:shadow-lg">
      <Link href={`/professional/${professional._id}`} className="block">
        <div className="flex items-center gap-4">
          {professional.avatarUrl && (
            <Avatar
              src={professional.avatarUrl}
              alt={professional.name}
              className="w-12 h-12 rounded-full"
              initials={professional.initials}
            />
          )}
          <div>
            <Heading>{professional.name}</Heading>
          </div>
        </div>

        <CardBody className="mt-4">
          {professional.bio && (
            <Text>{professional.bio.substring(0, 100)}...</Text>
          )}
          {professional.city && (
            <Text>
              <strong>City:</strong> {professional.city}
            </Text>
          )}

          {professional.roles && professional.roles.length > 0 && (
            <Text>
              <div className="flex flex-wrap gap-2">
                {professional.roles.map((role) => (
                  <ProfessionalRoleBadge key={role} role={role} />
                ))}
              </div>
            </Text>
          )}
        </CardBody>
      </Link>
      {currentMatterId && currentUser?.professional !== professional._id && (
        <InviteProfessionalButton professional={professional}>
          Invite
        </InviteProfessionalButton>
      )}
    </Card>
  );
};

export default ProfessionalGridItem;
